export const actions = {
	async list_paginate({ commit }, { companyId, params }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/referral-referral/`, { params })
			.then((res) => {
				return res
			})
	},

	async get_page({ commit }, { pageURL }) {
		return await useNuxtApp()
			.$api(pageURL)
			.then((res) => {
				return res
			})
	},
}
